import Toastify from 'toastify-js';
import 'toastify-js/src/toastify.css';

const toastConfig = {
  error: {
    duration: 3000,
    gravity: 'top', // 'top' or 'bottom'
    position: 'center', // 'left', 'center', or 'right'
    backgroundColor: '#e74c3c', // Red for errors
  },
  success: {
    duration: 3000,
    gravity: 'top', // 'top' or 'bottom'
    position: 'center', // 'left', 'center', or 'right'
    backgroundColor: '#2ecc71', // Green for success
  },
};

export function showToast(type, message = "") {
  const config = toastConfig[type];
  if (!config) {
    console.error(`Invalid toast type: ${type}`);
    return;
  }

  Toastify({
    ...config,
    text: message,
  }).showToast();
}